import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useProductLabels = (itemTypeVariantId?: number, enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['product-label', itemTypeVariantId],
    queryFn: () =>
      api
        .postBackUnitsListFilter({
          postBackUnitsListFilterRequest: {
            data: {
              itemTypeVariantId: itemTypeVariantId ? [itemTypeVariantId] : undefined,
            },
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
